import React, { useState } from 'react';
import FilePreviewModal from './FilePreviewModal';
import './EmailViewer.css';

const EmailViewer = ({ email, isOpen, onClose, onEdit = null, readOnly = false }) => {
    const [previewModal, setPreviewModal] = useState({ isOpen: false, fileUrl: '', fileName: '' });
    
    if (!isOpen || !email) return null;

    const formatDateTime = (dateString) => {
        if (!dateString) return 'Not specified';
        
        try {
            const date = new Date(dateString);
            return date.toLocaleString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: true
            });
        } catch (error) {
            return dateString;
        }
    };

    const getAttachmentFileName = (attachment) => {
        // Try different filename fields in order of preference
        return attachment.original_filename || 
               attachment.file_name || 
               attachment.name ||
               (attachment.attachment_file && typeof attachment.attachment_file === 'string' 
                   ? attachment.attachment_file.split('/').pop() 
                   : null) ||
               `Attachment ${attachment.id || 'Unknown'}`;
    };

    const getAttachmentUrl = (attachment) => {
        // Try different URL fields
        return attachment.attachment_file_url || 
               attachment.attachment_file || 
               attachment.file_url ||
               attachment.url;
    };

    const openFilePreview = (attachment) => {
        const fileUrl = getAttachmentUrl(attachment);
        const fileName = getAttachmentFileName(attachment);
        
        console.log('Opening file preview:', { fileUrl, fileName, attachment });
        
        if (fileUrl) {
            setPreviewModal({
                isOpen: true,
                fileUrl: fileUrl,
                fileName: fileName
            });
        } else {
            alert('File not available for preview');
        }
    };

    return (
        <>
            <div className="email-viewer-overlay" onClick={onClose}>
                <div className="email-viewer-container" onClick={(e) => e.stopPropagation()}>
                    <div className="email-viewer-header">
                        <h3 className="email-viewer-subject">
                            {(email.display_subject || email.subject || 'No Subject').toUpperCase()}
                        </h3>
                        <div className="email-viewer-actions">
                            {!readOnly && onEdit && (
                                <button 
                                    onClick={() => onEdit(email)} 
                                    className="email-viewer-btn email-viewer-btn-edit"
                                >
                                    Edit
                                </button>
                            )}
                            <button 
                                onClick={onClose} 
                                className="email-viewer-btn email-viewer-btn-close"
                            >
                                ×
                            </button>
                        </div>
                    </div>
                    
                    <div className="email-viewer-meta">
                        <div><strong>From:</strong> {email.from_email || email.from}</div>
                        <div><strong>To:</strong> {email.to_email || email.to}</div>
                        {(email.cc_email || email.cc) && (
                            <div><strong>CC:</strong> {email.cc_email || email.cc}</div>
                        )}
                        <div><strong>Date:</strong> {formatDateTime(email.email_date || email.date)}</div>
                        {(email.sent_by_name || email.user) && (
                            <div><strong>User:</strong> {email.sent_by_name || email.user}</div>
                        )}
                    </div>
                    
                    <div className="email-viewer-body">
                        <div 
                            dangerouslySetInnerHTML={{ __html: email.body }} 
                        />
                    </div>
                    
                    {email.attachments && email.attachments.length > 0 && (
                        <div className="email-viewer-attachments">
                            <strong>Attachments:</strong>
                            <ul>
                                {email.attachments.map((attachment, index) => {
                                    const fileName = getAttachmentFileName(attachment);
                                    const fileUrl = getAttachmentUrl(attachment);
                                    
                                    return (
                                        <li key={attachment.id || index}>
                                            {fileUrl ? (
                                                <a 
                                                    href="#" 
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        openFilePreview(attachment);
                                                    }}
                                                    className="attachment-link"
                                                    title={`Click to preview ${fileName}`}
                                                >
                                                    {fileName}
                                                </a>
                                            ) : (
                                                <span className="attachment-unavailable">
                                                    {fileName} (preview unavailable)
                                                </span>
                                            )}
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    )}

                    {/* Show message if no attachments */}
                    {(!email.attachments || email.attachments.length === 0) && (
                        <div className="email-viewer-attachments">
                            <strong>Attachments:</strong> <span>No attachments</span>
                        </div>
                    )}
                </div>
            </div>

            {/* File Preview Modal */}
            {/*<FilePreviewModal
                isOpen={previewModal.isOpen}
                fileUrl={previewModal.fileUrl}
                fileName={previewModal.fileName}
                onClose={() => setPreviewModal({ isOpen: false, fileUrl: '', fileName: '' })}
            />*/}
        </>
    );
};

export default EmailViewer;